import { Description, Field, Label, Textarea } from '@headlessui/react'
import clsx from 'clsx'
import { ChangeEventHandler } from 'react'
import { ChangeHandler, RefCallBack } from 'react-hook-form'

type BaseTextareaProps = {
  ref?: RefCallBack
  onChange?: ChangeEventHandler<HTMLTextAreaElement>
  onBlur?: ChangeHandler
  rows?: number
  size?: 'sm' | 'md'
  className?: string
  label?: string
  placeholder?: string
  description?: string
  error?: string
  value?: string
  disabled?: boolean
}

export const BaseTextarea = ({
  ref,
  label,
  placeholder,
  description,
  onChange,
  onBlur,
  size,
  rows,
  className,
}: BaseTextareaProps) => {
  const variantClasses = size === 'sm' ? 'rounded-lg px-3 py-2' : 'rounded-2xl px-4 py-3'
  return (
    <div className="w-full max-w-md">
      <Field>
        {label && <Label className="text-sm/6 font-medium text-white">{label}</Label>}
        {description && (
          <Description className="text-sm/6 text-white/50">{description}</Description>
        )}
        <Textarea
          ref={ref}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          className={clsx(
            'block w-full resize-none text-sm/6 disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none border-0 text-text-secondary ring ring-card-border dark:ring-card-border-dark focus:ring-2 focus:ring-card-border dark:focus:ring-card-border-dark placeholder-text-secondary',
            'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25',
            variantClasses,
            className
          )}
          rows={rows ? rows : 3}
        />
      </Field>
    </div>
  )
}
